// NotificationBellIcon.js
// Shared notification bell icon component used in Header and SideBarHeader
import React from "react";
import PropTypes from "prop-types";
import { faBell, faBellSlash } from "@fortawesome/free-regular-svg-icons";
import { FaIcon } from "../../shared/ui";
import "../../styles/NotificationBellIcon.css";

const NotificationBellIcon = ({ onClick, style, isEnabled, variant = "default" }) => (
  <div 
    className={`notification-bell-icon ${variant === "header" ? "notification-bell-icon--header" : ""}`}
    onClick={onClick}
    title={isEnabled ? "Pause notifications" : "Resume notifications"}
    tabIndex={-1}
  >
    <FaIcon
      icon={isEnabled ? faBell : faBellSlash}
      style={style}
      size="lg"
      fixedWidth
      tabIndex={-1}
    />
  </div>
);

NotificationBellIcon.propTypes = {
  onClick: PropTypes.func,
  style: PropTypes.object,
  isEnabled: PropTypes.bool,
  variant: PropTypes.oneOf(["default", "header"]),
};

export default NotificationBellIcon;
